// /src/config/constants.js
export const IMAGE_BASE_URL = "https://aadhavacademy.com/api/admin/";